// TODO: remove deprecated feature flags
type PortalFeatureFlags = {
  /**
   * Whether MFA status is displayed in an organization's members table
   */
  displayMfaInMembersTable: boolean
  /**
   * Whether the user can access the metrics tab
   */
  metrics: boolean
  /**
   * Whether the portal should audit app data interactions for the currenct user
   */
  auditAppDataInteraction: boolean
  /**
   * Whether the user can access the app forge
   */
  appForge: boolean
  /**
   * Whether the user can access the new app forge
   */
  appForgeNew: boolean
  /**
   * Whether the user sees the renamed "app" to "database"
   */
  appToDatabaseRename: boolean
  /**
   * Whether the user can issue writes to user-defined collections using the SDK
   */
  sdkWriteEnabled: boolean
  /**
   * Whether the user can access the settings pages in the app builder
   */
  enableForgeSettings: boolean
  /**
   * Whether the user can see the DQL auth webhook messaging
   */
  enableDqlAuthWebhook: boolean
  /**
   * Whether the user can create non-image attachments
   */
  forgeNonImageAttachments: boolean
  /**
   * Whether the user can create attachment fields
   */
  enableForgeAttachments: boolean
  /**
   * Whether the user can access the MongoDB DQL strict mode in Mongo Connection settings
   */
  mongoDqlStrictMode: boolean
  /**
   * Whether the user can request all device data, not just logs
   */
  requestDeviceData: boolean
  /**
   * Whether the user can request device metrics. This is an
   * additional flag for requesting device data, as metrics
   * downloads are currently not available.
   */
  requestDeviceMetrics: boolean
  /**
   * Whether the user can access self-service SSO configuration
   */
  selfServiceSso: boolean
}

/** A type that represents all of our feature flags. These are managed
 *  in LaunchDarkly, and can be found at:
 *  https://app.launchdarkly.com/default/{environment}/features
 *
 *  NOTE: flags can come back as undefined, so we need to use Partial
 **/
export type FeatureFlags = Partial<PortalFeatureFlags>

export { useFeatureFlags } from './useFeatureFlags'
